import React, { memo, useMemo } from 'react'

import classnames from 'classnames'
import { makeStyles } from '@material-ui/core/styles'

import style from './style'
import ActionMenu from './ActionMenu'
import {
  CAMPAIGN_ENUM_TYPES,
  CAMPAIGN_INTERNAL_STATUSES,
  CAMPAIGN_SUBTYPES_ENUM,
} from '../../../../../../../../shared/constants'

const ColumnItem = ({ provided, snapshot, item, stage, getActionsCard }) => {
  const classes = useColumnItemStyle({
    isDragging: snapshot.isDragging,
    draggableStyle: provided.draggableProps.style,
  })

  const {
    campaignId,
    campaignName,
    internalStatusChangedDate,
    clientName,
    totalCosts,
    startDate,
    flyerType,
    flyerWeight,
    missionsCount,
    campaignDuration,
    submitter,
    type,
    subtype,
    cityName,
    isArchivedCity,
    internalStatus,
    error,
    createdDate,
  } = item

  const isDM = type === CAMPAIGN_ENUM_TYPES.DIRECTMAIL
  const options = getActionsCard(stage, item)
  const isDeclined = useMemo(
    () => internalStatus === CAMPAIGN_INTERNAL_STATUSES.REJECTED,
    [internalStatus, CAMPAIGN_INTERNAL_STATUSES.REJECTED],
  )

  const getCampaignTypeLabel = (type, subtype) => {
    switch (subtype || type) {
      case CAMPAIGN_ENUM_TYPES.LETTERBOX:
        return 'D2D'
      case CAMPAIGN_SUBTYPES_ENUM.EDDM:
        return 'EDDM'
      case CAMPAIGN_SUBTYPES_ENUM.ADM:
        return 'ADM'
      case CAMPAIGN_ENUM_TYPES.HANDTOHAND:
        return 'H2H-PL'
      default:
        return '-'
    }
  }

  const campaignType = getCampaignTypeLabel(type, subtype)

  const missionPerWeek =
    missionsCount && campaignDuration
      ? Math.round((missionsCount * 2) / campaignDuration) / 2
      : null

  const handleCopyCampaignId = async event => {
    event.preventDefault()
    event.stopPropagation()
    event.persist()
    try {
      const content = event.target.textContent
      await navigator.clipboard.writeText(content)
      event.target.textContent = 'Copied!'
      setTimeout(() => {
        event.target.textContent = content
      }, 1500) // Reset after a short time
    } catch (err) {
      console.error('Failed to copy text: ', err)
    }
  }

  return (
    <div
      className={classes.body}
      ref={provided.innerRef}
      {...provided.draggableProps}
      {...provided.dragHandleProps}
    >
      <div className={classes.headerRow}>
        <div onClick={handleCopyCampaignId} className={classes.campaignId}>
          {campaignId}
        </div>
        {isDeclined ? (
          <div className={classnames(classes.date, classes.rejected)}>
            Rejected
          </div>
        ) : !!error ? (
          <div className={classnames(classes.date, classes.rejected)}>
            Error: {error}
          </div>
        ) : (
          <div className={classes.date}>{internalStatusChangedDate}</div>
        )}

        <div>
          <ActionMenu options={options} />
        </div>
      </div>
      <div>
        <div className={classes.row}>{clientName}</div>
      </div>
      <div className={classnames(classes.row, classes.campaignName)}>
        {campaignName}
      </div>
      <div className={classes.row}>
        <span className={classes.name}>Amount:</span>
        <span>{totalCosts}</span>
      </div>
      <div className={classes.row}>
        <span className={classes.name}>Created Date:</span>
        <span> {createdDate}</span>
      </div>
      <div className={classes.row}>
        <span className={classes.name}>Submitted:</span>
        <span> {submitter}</span>
      </div>
      <div className={classes.row}>
        <span className={classes.name}>Launch:</span>
        <span> {startDate}</span>
      </div>
      {!isDM ? (
        <div className={classes.row}>
          <span className={classes.name}>{`City:`}</span>
          <span
            className={classnames('', { [classes.archived]: isArchivedCity })}
          >
            {isArchivedCity ? `ARCHIVED [${cityName}]` : cityName}
          </span>
        </div>
      ) : null}

      <div className={classes.flyers}>
        <div>{campaignType}</div>
        <div>{flyerType}</div>
        {!isDM ? <div>{flyerWeight} GSM</div> : null}
      </div>
      {!isDM ? (
        <div className={classes.statistics}>
          <div>{missionsCount || 0} m</div>
          <div>{missionPerWeek || 0} pw</div>
          <div>{campaignDuration || 0} w</div>
        </div>
      ) : null}
    </div>
  )
}

const useColumnItemStyle = makeStyles(props => ({
  ...style,
  body: {
    ...style.body,
    boxShadow: props.isDragging ? '1.7px 1.7px 8.6px rgba(0, 0, 0, 0.25)' : '',
    ...props.draggableStyle,
  },
}))

export default memo(ColumnItem)
